// components/Tasks/FilteringRules/utils.js

let _id = Date.now();
export const nextId = () => ++_id;

export const createEmptyRule = () => ({
  id: nextId(),
  field: "",
  operator: "",
  value: "",
  valueMin: "",
  valueMax: "",
});

// Подсчёт активных правил
export function countActiveRules(rules) {
  if (!Array.isArray(rules)) return 0;
  return rules.filter(r => r.field && r.operator).length;
}

// Генерация текстового описания логики
export function describeLogic(matchType, rulesCount, t) {
  if (rulesCount === 0) return t.noRules;
  if (rulesCount === 1) return t.singleRule;
  return matchType === "all" 
    ? t.allRulesMustMatch 
    : t.anyRuleCanMatch;
}